import { render, staticRenderFns } from "./Mantra.vue?vue&type=template&id=1ec07c3c&scoped=true"
import script from "./Mantra.vue?vue&type=script&lang=js"
export * from "./Mantra.vue?vue&type=script&lang=js"
import style0 from "./Mantra.vue?vue&type=style&index=0&id=1ec07c3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec07c3c",
  null
  
)

export default component.exports